export * from './UniversityMarkerIcon'
